{
  "it": {
    "validation": {
      "emailAddressDemo": "L'indirizzo email di un contatto in questa organizzazione demo deve terminare con '{email_address_suffix}' o '{'@'}ziggu.io'",
      "emailTaken": "L'indirizzo email è già in uso",
      "errorsInLanguages": "Alcune traduzioni contengono errori, verifichi: {languages}",
      "fix_errors": "Salvataggio non riuscito, corregga gli errori",
      "import": {
        "inclusion": "Errore alla riga {rowNumber}, colonna {columnNumber}: {headerName} non è incluso nell'elenco",
        "inclusion_values": "con valori consentiti: {values}",
        "invalid": "Errore alla riga {rowNumber}, colonna {columnNumber}: {headerName} non è valido",
        "required": "Errore alla riga {rowNumber}, colonna {columnNumber}: è richiesto un valore per {headerName}",
        "unique": "Errore alla riga {rowNumber}: {headerName} non è univoco, esiste un'altra riga con questo valore"
      },
      "nameAlreadyTaken": "Il nome è già in uso",
      "needCompany": "L'organizzazione è obbligatoria",
      "needName": "Il nome è obbligatorio"
    }
  }
}
